import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import ASSIGNLEADAPI from "../../Api/assignLead";

export const getAssignLeads = createAsyncThunk("assignLead/getAssignLeads", async (params, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.getAssignLeads(params);

        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const createAssignLead = createAsyncThunk("assignLead/createAssignLead", async (formData, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.createAssignLead(formData);
        console.log(response)
         const message=(response.message)
        
            thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

// export const updateAssignLead = createAsyncThunk("assignLead/updateAssignLead", async ({ assignLeads_id, formData }, thunkAPI) => {
//     try {
//         const response = await ASSIGNLEADAPI.updateAssignLead(assignLeads_id, formData);
//         return response.data;
//     } catch (error) {
//         if (error.response && (error.response.status === 401 || error.response.status === 403)) {
//             EventBus.dispatch("logout");
//         }
//         const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
//         thunkAPI.dispatch(setMessage(message));
//         return thunkAPI.rejectWithValue(message);
//     }
// });

export const deleteAssignLead = createAsyncThunk("assignLead/deleteAssignLead", async (assignLeads_id, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.deleteAssignLead(assignLeads_id); // Corrected API call
        return assignLeads_id; // Return the lead id to remove from state
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const getAssignLeadById = createAsyncThunk("assignLead/getAssignLeadById", async (assignLeads_id, thunkAPI) => {
    try {
        const response = await ASSIGNLEADAPI.getAssignLeadById(assignLeads_id);
        console.log(response)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const assignLeadSlice = createSlice({
    name: "assignLead",
    initialState: {
        assignLeads: [],
        totalPages: ""
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAssignLeads.fulfilled, (state, action) => {
                console.log(action)
                state.assignLeads = action.payload.data;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(getAssignLeadById.fulfilled, (state, action) => {
                state.assignLeads = action.payload.data;
            })
            .addCase(createAssignLead.fulfilled, (state, action) => {
                state.assignLeads.push(action.payload.data); 
            })
            // .addCase(updateAssignLead.fulfilled, (state, action) => {
            //     const updatedAssignLead = action.payload.data;
            //     state.assignLeads = state.assignLeads.map((assignLead) => (assignLead._id === updatedAssignLead._id ? updatedAssignLead : assignLead));
            // })
            .addCase(deleteAssignLead.fulfilled, (state, action) => {
                state.assignLeads = state.assignLeads.filter((lead) => lead.id !== action.payload);
            });
    },
});

const { reducer } = assignLeadSlice;
export default reducer;
